import { EXPORT_HEADERS, KEYS_TO_COLLECT } from "@src/constants";
import { DownloadCsvButtonProps } from "@src/types";
import React from "react";

const DownloadCSVButton: React.FC<DownloadCsvButtonProps> = ({ data }) => {
  const downloadCSV = () => {
    const dataValueCSV = createUpdateData(data);
    const dataCSVWithHeaders: any[][] = [EXPORT_HEADERS, ...dataValueCSV];

    const csvContent = dataCSVWithHeaders
      .map((row) => row.join(","))
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "baseEditor";
    document.body.appendChild(a);

    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return <button onClick={downloadCSV}>Download CSV</button>;
};

const createUpdateData = (data: any[]) => {
  const dataForCSV: any[][] = data.map((obj) =>
    KEYS_TO_COLLECT.flatMap((key) => {
      if (key === "off_target_analysis") {
        return obj[key]?.split("#").map(Number);
      } else {
        return obj[key];
      }
    })
  );
  return dataForCSV;
};

export { DownloadCSVButton };
